// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmdEnrollmentResponseModel {
    static getAttributeTypeMap() {
        return EmdEnrollmentResponseModel.attributeTypeMap;
    }
}
EmdEnrollmentResponseModel.discriminator = undefined;
EmdEnrollmentResponseModel.additionalProperties = false;
EmdEnrollmentResponseModel.attributeTypeMap = [
    {
        "name": "tcAccountId",
        "baseName": "tcAccountId",
        "type": "string"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "iBondId",
        "baseName": "iBondId",
        "type": "string"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=emdEnrollmentResponseModel.js.map